<template>
    <div class="py-0" style="right: 0; left: 0;">
        <!-- <b-navbar type="dark" variant="primary" toggleable> -->
        <nav class="navbar navbar-expand-lg navbar-custom py-0">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCustom">
            <i class="fa fa-bars fa-lg py-1 text-white"></i>
          </button>
          <div class="collapse navbar-collapse" id="navbarCustom">
            
            <ul class="navbar-nav">
              <li class="nav-item"> 
                  <a class="nav-link" href="/#/dashboard">HOME</a>
              </li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    MY ACCOUNT
                  </a>
                  <div class="dropdown-menu dropdown-menu-left" v-if="RegType<10" aria-labelledby="navbarDropdown">
                      <!-- <a class="dropdown-item" href="/#/viewprofile"><i class="fa fa-pencil-alt"></i> <span>View Profile</span></a>  -->
                      <a v-if="validProfile" class="dropdown-item" href="/#/profile"><i class="fa fa-pencil-alt"></i> <span >Edit Profile</span></a>
                      <a class="dropdown-item" href="/#/viewapp"><i class="fa fa-desktop"></i> <span>View Application</span></a>
                      <a class="dropdown-item" href="/#/results"><i class="fa fa-star"></i> <span>View Result</span></a>
                      <a class="dropdown-item" href="/#/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></a>
                      <a class="dropdown-item" href="/#/letter"><i class="fa fa-envelope"></i> <span>Intimation Letter</span></a>
                      <a class="dropdown-item" href="/#/bformlist"><i class="fa fa-envelope"></i> <span>B-Form</span></a>
                      <a class="dropdown-item" href="/#/changePassword"><i class="fa fa-key"></i> <span>Change Password</span></a>
                      
                  </div>
                  <div class="dropdown-menu dropdown-menu-left" v-if="RegType==11" aria-labelledby="navbarDropdown">
                      
                      <a class="dropdown-item" href="/#/registrations"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></a>
                      <a class="dropdown-item" href="/#/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></a>
                      <a class="dropdown-item" href="/#/employerprofile"><i class="fa fa-envelope"></i> <span>Print Profile</span></a>
                  </div>
                  <div class="dropdown-menu dropdown-menu-left" v-if="RegType==12" aria-labelledby="navbarDropdown">
                      
                      <a class="dropdown-item" href="/#/registrations"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></a>
                      <a class="dropdown-item" href="/#/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></a>
                      <a class="dropdown-item" href="/#/guardprofile"><i class="fa fa-envelope"></i> <span>Print Profile</span></a>
                  </div>
                  <div class="dropdown-menu dropdown-menu-left" v-if="RegType==13" aria-labelledby="navbarDropdown">                         
                      <a class="dropdown-item" href="/#/agencyregistration"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></a>
                      <a class="dropdown-item" href="/#/registrationfees"><i class="fa fa-pencil-alt"></i> <span>Pending Payment</span></a>
                      <a class="dropdown-item" href="/#/agencyemployermap"><i class="fa fa-pencil-alt"></i> <span>Registered Employers</span></a>
                      <a class="dropdown-item" href="/#/agencyguardmap"><i class="fa fa-pencil-alt"></i> <span>Guards Registered with Agency</span></a>
                      <a class="dropdown-item" href="/#/paymentlist"><i class="fa fa-credit-card"></i> <span>Payment Reciept</span></a>
                      <a class="dropdown-item" href="/#/agencyprofile"><i class="fa fa-envelope"></i> <span>Print Profile</span></a>
                  </div>                  
              </li>
              <li class="nav-item dropdown" v-if="RegType==13" >
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Apply For Exemption
                  </a>
                  <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarDropdown">
                      <a class="dropdown-item" href="/#/applyforexemption"><i class="fa fa-pencil-alt"></i> <span>New Application</span></a>
                      <a class="dropdown-item" href="/#/pendingapplication"><i class="fa fa-pencil-alt"></i> <span>Inprogress Applications</span></a>
                      <a class="dropdown-item" href="/#/ExemptionList"><i class="fa fa-pencil-alt"></i> <span>Exemted Applications</span></a>
                      <!-- <a class="dropdown-item" href="/#/NotificationList"><i class="fa fa-pencil-alt"></i> <span>Agency Gazette</span></a> -->
                     
                  </div>
              </li>
              
            </ul>
          
            <span class="ml-auto mr-5" >
              <ul class="navbar-nav">
                <li class="nav-brand">
                    <a class="nav-link" href="#">WELCOME {{username}}</a>
                </li>
                <!-- <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Language
                  </a>
                  <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarDropdown">
                      <a class="dropdown-item" href="#" @click="setLang('en', 'English')">English</a>
                      <a class="dropdown-item" href="#" @click="setLang('mr','मराठी')">मराठी</a>
                  </div>
                </li> -->
                <li class="nav-item dropdown" style="border-left: 1px solid #fff;">
                  <a class="nav-link" href="#" @click="logout">LOGOUT</a>                      
                </li>
              </ul>
            </span>
          </div>
        </nav>
        <!-- </b-navbar> -->

    </div>
</template>

<script>

export default {

  data(){
    return{
      
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.replace("/");
    },
    login() {
      this.$router.replace("/");
    },
    setLanguage() {
      var temp_lang = document.getElementsByClassName("goog-te-combo")[0].value;
      var flang =
        temp_lang == "hi" ? "हिन्दी" : temp_lang == "mr" ? "मराठी" : "English";

      document.querySelector(".lang-bar a.dropdown-toggle").innerHTML = flang;
    }
  },
  computed:{
    username() {
      var nme = this.$store.getters.loggedUser;
      return nme.UserName;
    },
    RegType(){
      var nme = this.$store.getters.loggedUser;
      return nme.RegistrationType;
    },
    validProfile(){
      var nme = this.$store.getters.loggedUser;
      return nme.ValidProfile;
    }
  }
};
</script>

<style scoped>
.navbar-custom {
  background-color: #2e4b90 !important;
  min-height: 70px;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  line-height:54px;
  font-family: "Open sans", sans-serif;
  text-transform: uppercase;
}
/* change the brand and text color */
.navbar-custom .navbar-brand,
.navbar-custom .navbar-text {
  color: white;
}
/* change the link color */
.navbar-custom .navbar-nav .nav-link {
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  padding-left: 30px;
  text-transform: uppercase;
}
/* change the color of active or hovered links */
.navbar-custom .nav-item.active .nav-link,
.navbar-custom .nav-item:hover .nav-link {
  color: #f4ff60;
  padding-left: 30px;
}

.navbar-custom .dropdown-menu {
  background-color: #2e4b90 !important;
  margin-left:-50px;
}
.navbar-custom .dropdown-menu-left {
  background-color: #2e4b90 !important;
  margin-left:10px !important;
}
.navbar-custom .dropdown-item {
  color: #ffffff;
  height: 40px !important;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 34px;
  padding-left: 30px;
  text-transform: uppercase;
}
.navbar-custom .dropdown-item:hover,
.navbar-custom .dropdown-item:focus {
  /* color: #333333;
  background-color: rgba(255, 255, 255, 0.5); */
  color: black;
  background-color: white;
  display: block;
  
}

/* Dropdown Button */
.navbar-custom .dropbtn {
  height: 70px;
  background-color: #2e4b90 !important;
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;

  font-family: "Open sans", sans-serif;
  border: none;
  padding-left: 30px;
  text-transform: uppercase;
}

/* The container <div> - needed to position the dropdown content */
.navbar-custom .dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #2e4b90;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: white;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content  {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn:hover {
  background-color: #f4ff60;
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a{ margin-top:-15px;}
</style>


// WEBPACK FOOTER //
// src/components/RegistrationNavbar.vue